<template>
  <el-dialog
    title="新增换货单"
    custom-class="create-exchange-dialog"
    :visible.sync="dialogVisible"
    width="1100px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="exchange-toolbar-tip">换货不涉及资金往来；仅可对质检不合格且尚未换货的数量发起。确定后写入换货管理，采购单仍为待收货，后续继续走收货单。</div>
    <el-table
      :data="skuList"
      border
      stripe
      size="mini"
      max-height="480"
      show-summary
      :summary-method="getSummaries"
      v-loading="loading"
      element-loading-text="加载中..."
      class="exchange-table"
    >
      <el-table-column type="index" label="序号" width="48" align="center"></el-table-column>
      <el-table-column prop="sku" label="SKU" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="fnsku" label="FNSKU" min-width="110" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseColorName" label="颜色" width="72" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="model" label="型号" width="85" align="left" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseQuantity" label="采购数量" width="80" align="right"></el-table-column>
      <el-table-column prop="qualityFail" label="质检不合格" width="96" align="right"></el-table-column>
      <el-table-column prop="exchangedQty" label="已换货" width="80" align="right"></el-table-column>
      <el-table-column prop="exchangeableQty" label="可换数量" width="80" align="right"></el-table-column>
      <el-table-column prop="exchangeQuantity" label="本次换货" width="96" align="center">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            placeholder=""
            v-model="scope.row.exchangeQuantity"
          ></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="exchange-remark-row">
      <span class="exchange-remark-label">备注</span>
      <el-input
        type="textarea"
        :rows="2"
        size="small"
        maxlength="200"
        show-word-limit
        placeholder="选填"
        v-model="remark"
      ></el-input>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { requestModules } from "@r";

const SUM_PROPS = ["purchaseQuantity", "qualityFail", "exchangedQty", "exchangeableQty", "exchangeQuantity"];

export default {
  name: "CreateExchangeDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      skuList: [],
      remark: "",
    };
  },
  methods: {
    open(selectedList) {
      this.dialogVisible = true;
      this.skuList = [];
      this.remark = "";
      this.loadSkus(selectedList || []);
    },
    toNumberOrZero(value) {
      if (value === "" || value === null || value === undefined) return 0;
      return Number(value) || 0;
    },
    loadSkus(selectedList) {
      this.loading = true;
      requestModules
        .fetchPurchaseOrderExchangeSkus({
          selectedList: JSON.stringify(selectedList),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取换货明细失败");
            this.dialogVisible = false;
            return;
          }
          this.skuList = (res.ldata || []).map(row => ({
            ...row,
            qualityFail: Number(row.qualityFail) || 0,
            exchangedQty: Number(row.exchangedQty) || 0,
            exchangeableQty: Number(row.exchangeableQty) || 0,
            exchangeQuantity: Number(row.exchangeQuantity) || Number(row.exchangeableQty) || 0,
          }));
        })
        .catch(() => {
          this.$message.error("获取换货明细失败");
          this.dialogVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSummaries({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (SUM_PROPS.includes(column.property)) {
          sums[index] = this.sumBy(data, column.property);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    sumBy(data, key) {
      return (data || []).reduce((total, row) => total + (Number(row[key]) || 0), 0);
    },
    submit() {
      if (!this.skuList.length) {
        this.$message.warning("没有可换货的明细");
        return;
      }
      const payload = [];
      for (let i = 0; i < this.skuList.length; i++) {
        const row = this.skuList[i];
        const qty = this.toNumberOrZero(row.exchangeQuantity);
        if (qty < 0) {
          this.$message.warning("换货数量不能为负数");
          return;
        }
        if (!Number.isInteger(qty)) {
          this.$message.warning("换货数量须为正整数");
          return;
        }
        const maxQty = Number(row.exchangeableQty) || 0;
        if (qty > maxQty) {
          this.$message.warning(`SKU ${row.sku || ""} 换货数量不能超过可换数量 ${maxQty}`);
          return;
        }
        if (qty > 0) {
          payload.push({
            _id: row._id,
            exchangeQuantity: qty,
          });
        }
      }
      if (!payload.length) {
        this.$message.warning("请至少填写一条换货数量");
        return;
      }

      this.submitting = true;
      requestModules
        .createPurchaseOrderExchange({
          skuList: JSON.stringify(payload),
          remark: this.remark || "",
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "新增换货单失败");
            return;
          }
          const groupId = (res.mdata && res.mdata.exchangeGroupId) || "";
          this.$message.success(groupId ? `新增换货单成功：${groupId}` : "新增换货单成功");
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(() => {
          this.$message.error("新增换货单失败");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleClose() {
      this.skuList = [];
      this.remark = "";
    },
  },
};
</script>

<style lang="scss">
.create-exchange-dialog {
  .el-dialog__body {
    overflow-x: hidden;
    padding: 12px 16px;
  }

  .exchange-toolbar-tip {
    color: #909399;
    font-size: 12px;
    margin-bottom: 12px;
    line-height: 1.5;
  }

  .exchange-remark-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 12px;

    .exchange-remark-label {
      flex: none;
      width: 40px;
      line-height: 32px;
      color: #606266;
      font-size: 13px;
    }

    .el-textarea {
      flex: 1;
    }
  }

  .exchange-table {
    width: 100%;

    .el-table__body-wrapper,
    .el-table__header-wrapper,
    .el-table__footer-wrapper {
      overflow-x: hidden !important;
    }

    .el-input--mini .el-input__inner {
      padding: 0 4px;
      height: 26px;
      line-height: 26px;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
}
</style>
